import type { IconSvgObject } from './types';

const Award04Icon: IconSvgObject = [
  ["path", { d: "M12 2L18.5 5.5V12.5L12 16L5.5 12.5V5.5L12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 14L7 22L12 20L17 22L16 14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 9L11.5 10.5L14 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Award04Icon;
